<template>
  <component-wrapper class="contact-tiles-fi">
    <grid-container-fi>
      <div class="fi-col-start-1 fi-col-end-13 lg:fi-col-start-2 lg:fi-col-end-12">
        <richtext-fi
          v-if="fields?.text?.value || isEditMode"
          class="contact-tiles-fi__text"
          :html-content="fields.text"
        />

        <div class="contact-tiles-fi__contact-tiles">
          <contact-tile-fi
            v-for="(contactTilem, idx) in fields.contactTiles"
            :key="idx"
            :fields="contactTilem.fields"
          />
        </div>
      </div>
    </grid-container-fi>
  </component-wrapper>
</template>

<script>
import { RichtextFi } from 'atoms';
import ComponentWrapper from 'components/component-wrapper/ComponentWrapper';
import ContactTileFi from 'components/contact-tile-fi/ContactTileFi';
import GridContainerFi from 'components/grid-fi/GridContainerFi';

export default {
  name: 'ContactTilesFi',
  components: {
    ComponentWrapper,
    GridContainerFi,
    ContactTileFi,
    RichtextFi,
  },
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<style scoped lang="scss">
@import './contact-tiles-fi';
</style>
